import React from 'react';
import TanninsImg from '../../assets/images/tanninibordo.png'
import { useTranslation } from 'react-i18next';
import './Tannins.css'
function Tannins() {
  const { t } = useTranslation();

  const products = [
 
    {
        name: t('ICEtan BLEND'),
        description: t('Formulated for the refinement of red and rosé wines. Obtained from the association of ellagic tannins extracted from Quercus Petrea and Quercus Alba wood, seasoned outdoors.It improves the gustatory balance of the wine, giving character to wines aged in “tired” wooden containers.'),
      },
      {
        name: t('ICEtan BROWN'),
        description: t('Ellagic tannin with a high content of tannic acid, specially selected for its antioxidant properties. It contributes to the protection of color from the enzymatic degradation of grape polyphenol oxidases.Facilitates anthocyanin-tannin condensation, promoting co-pigmentation. It is used on pressed grapes from the early stages of winemaking.'),
      },
      {
        name: t('ICEtan COLOUR'),
        description: t('Adjuvant based on grape seed and ellagic tannins, slow release and readily soluble macromolecules.It acts on the stability of the color by promoting the formation of covalent bonds thanks to the grape seed tannin and prevents the oxidation of the anthocyanins thanks to the strong antioxidant and anti-radical power of the ellagic tannin. The macromolecules provided give the wines softness and volume, also contributing to the protection of the color in the early stages of winemaking.'),
      },
      {
        name: t('ICEtan Easy Protect'),
        description: t('ICEtan Easy protect is a mixture of ellagic tannins extracted from different botanical species with a high protective power against natural oxidase enzymes, acting in synergy with SO2. Its action helps protect the color and promote anthocyanin-tannin condensation, preserving the tannic content naturally present in the grape.'),
      },
      {
        name: t('ICEtan ESPRESSO'),
        description: t('Aging adjuvant of the highest quality based on ellagic tannins extracted from the heartwood of seasoned and toasted oak wood. It is used in the production of great red wines.'),
      },
      {
        name: t('ICEtan FINISSAGE'),
        description: t('Aging adjuvant of the highest quality based on ellagic tannins extracted from the heartwood of seasoned and toasted oak wood. It is used in the production of great red wines.'),
      },
      {
        name: t('ICEtan FIX'),
        description: t('Blend of condensed tannins specially designed to improve the structure and stabilize the color. The combination of condensed tannins of a catechetical nature with different molecular weights allows for greater stabilization of the anthocyanins and an increase in the total polyphenol content.'),
      },
      {
        name: t('ICEtan FRUIT'),
        description: t('Formulated from a careful selection of raw materials, focusing on the different extraction areas of the trunkof the plant. The different types of tannin contained in this blend enhance the structure and tannic perception of some vines such as Sangiovese during the aging period as well as increasing the sweet fruity notes naturally present in the grapes.'),
      },
      {
        name: t('ICEtan G'),
        description: t('Float tannin, highly purified, having low surface electrical charge. It is indicated for the treatment of wines in which the structure is to be strengthened and antioxidant and antioxidant activity is desired. Finds good application in white wines. It is indicated for protecting musts from the action of grape polyphenol oxidases. It is an effective tool in the winemaking of botrytised grapes'),
      },
      
      {
        name: t('ICEtan LAVICO'),
        description: t('It is a formulation based on tannins in microgranular form for the refinement of red, rosé and white wines. ICEtan Lavico has been designed to increase the structure of the wine, to fill the body deficiencies and reduce the vegetal notes derived from the imperfect ripening of the grapes.'),
      },
   
      {
        name: t('ICEtan PRO'),
        description: t('Mixture of ellagic tannins and grape tannins rich in polyphenolic substances. Product specially designed to be used from the early stages of refinement. It contributes to the regulation of the oxidation-reduction potential of wines and to color stabilization.'),
      },
      {
        name: t('ICEtan SKIN'),
        description: t('Grape proanthocyanidin tannin obtained by extraction, selection and purification of phenolic compounds from white grape skin. It strengthens the structure of white and red wines by increasing the perception of volume, decreasing the aggressiveness of alcohol and acidity while respecting the personality of the wine. It facilitates the evolution of wine in wood.'),
      },
      {
        name: t('ICEtan SUPRA'),
        description: t('Mixture of ellagic and condensed tannin designed to protect the color and promote anthocyanin/tannin condensation in the maceration of red grapes. The condensed fraction allows to increase the formation of stable covalent bonds with the coloring substances. The presence of ellagic tannins allows the color to be protected from oxidation right from pressing and the first stages of extraction.'),
      },
      {
        name: t('ICEtan SUPREME'),
        description: t('Tannin extracted from the finest portion of Castanea Sativa wood, using a unique extraction technique that allows for a particularly pure tannin to be obtained.'),
      },
     
      {
        name: t('ICEtan V'),
        description: t('Grape proanthocyanidin tannin obtained by extraction and purification of grape seeds. Suitable for giving structure and filling tannic deficiencies in the mid-mouth.It favors the stabilization of the chromatic fraction from the early stages of fermentation and during the refinement period'),
      },
      {
        name: t('ICEtan VOLUME'),
        description: t('Blend of tannins extracted from untoasted seasoned woods and catechetical tannins. It has an excellent ability to integrate the gustatory structure of wines and regulate oxidation-reduction phenomena by mediating the action of oxygen, removing reduction states. It is used starting from racking and throughout the refinement period. Suitable for adding structure to red wines.'),
      },
     
      
  
  ];

  return (
  <>

<div className='mainTanninsImg'>
  <div className='TanninsImg1'></div>

  <div className="TanninsImg2">
    <h1 className="TanninsTitle">{t("Tannins")}</h1>
    <img src={TanninsImg} alt="Tannins" className="TanninsImage" />
  </div>
</div>

    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          {/* <img src={product.image} alt={product.name} /> */}
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
    </>
  );
}

export default Tannins;
